import CodePhoneSelect from 'components/forms/CodePhoneSelect'
import React from 'react'
import { Field } from 'redux-form'
import { useTranslation } from 'react-i18next'
import { required } from "redux-form-validators"

export function PhoneNumberPrefixInput() {
    const { t } = useTranslation()
    
    return <div className='form-group row'>
            <label className='col-md-6 control-label  required'>{t('profile.mobilePhonePrefix')}
            </label>
        <div className='col-md-6'>
            {/* Selector de Prefijo Dinámico */}
            <Field
                component={CodePhoneSelect}
                name='mobilePhonePrefix'
                className='form-control'
                validate={[
                    required(),
                ]}
            />
        </div>
    </div>
}